<template>
  <vs-row vs-justify="center">
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      <vs-card id="v-step-0">
        <SalesSummery
          :name="name"
          :saldo="saldo"
          :active_vouchers="active_vouchers"
          :saldo_history="saldo_history"
          :saldo_labels="saldo_labels"
          :saved_money="saved_money"
        ></SalesSummery>
      </vs-card>
    </vs-col>
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      <PointsExchangeModule
        header="W tym module możesz wymienić swoje punkty na kupony, obniżające ceny zakupów w
          sklepie TVOkazje lub przy zamówieniach przez telefon."
        :refreshUserData="this.refreshUserData"
      ></PointsExchangeModule>
    </vs-col>
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      <vs-card id="v-step-5">
        <EmailCampaign :voucher_amounts="voucher_amounts"></EmailCampaign>
      </vs-card>
    </vs-col>
    <!-- <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
      <vs-card id="v-step-6">
        <GalleryCarousel :posts="posts"></GalleryCarousel>
      </vs-card>
    </vs-col> -->
    <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
      <vs-card class="bg-primary info-card" id="v-step-7">
        <div>
          <h3 class="card-title text-white">Wykorzystane kupony</h3>
          <vs-row class="voucher-container">
            <vs-col vs-lg="6" vs-xs="8" vs-sm="6">
              <div
                style="height:90px;width: 150px; position:relative;"
                class="mt-4 mb-4"
              >
                <i class="mr-2 mdi mdi-ticket-percent voucher-icon"></i>
              </div>
            </vs-col>
            <vs-col
              vs-lg="6"
              vs-xs="4"
              vs-sm="6"
              class="d-flex align-items-center justify-content-end"
            >
              <div>
                <div class="font-medium text-white mb-0 h1">{{ used_sum }}</div>
                <span class="text-white op-5 h3 font-weight-normal"
                  >Użytych kuponów</span
                >
              </div>
            </vs-col>
          </vs-row>
        </div>
      </vs-card>
    </vs-col>
    <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
      <vs-card class="bg-info card-no-padding info-card" id="v-step-8">
        <h3 class="card-title text-white p-3">
          <span class="mb-2 d-block">Zebrane punkty</span>
          <div class="h1"><i class="ti-arrow-up"></i> {{ points_history }}</div>
        </h3>
        <div class="coin-icon-container text-center">
          <i class="mdi mdi-coin coin-icon"></i>
        </div>
      </vs-card>
    </vs-col>
    <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
      <vs-card
        class="info-card"
        id="v-step-9"
        title="Liczba punktów zebranych w czasie"
      >
        <vue-apex-charts
          type="area"
          height="190"
          :options="chartOptions"
          :series="series"
          title="Liczba punktów zebranych w czasie"
        ></vue-apex-charts>
      </vs-card>
    </vs-col>
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      <vs-card id="v-step-10">
        <!-- Header -->
        <div class="d-sm-flex align-items-center justify-content-between">
          <div>
            <h3 class="card-title">Historia</h3>
            <h5 class="card-subtitle text-muted font-weight-normal">
              Najnowsze transakcje
            </h5>
          </div>
          <div class="">
            <vs-button color="success" type="filled" to="/history" class="mb-3"
              >Przejdź do całej historii</vs-button
            >
          </div>
        </div>
        <MonthTable :history="history"></MonthTable>
      </vs-card>
    </vs-col>
    <!-- <vs-card id="v-step-11">
      <h3 class="card-title d-flex">Porady blogowe</h3>
      <MultislideCarousel :posts="posts"></MultislideCarousel>
    </vs-card> -->

    <Footer></Footer>

    <v-tour
      v-if="windowWidth > 800"
      name="myTour"
      :steps="headerDesktopSteps.concat(steps)"
      :options="myOptions"
      :callbacks="callbacks"
    >
      <!-- eslint-disable -->
      <template slot-scope="tour">
        <v-step
          v-if="tour.currentStep === index"
          v-for="(step, index) of tour.steps"
          :key="index"
          :step="step"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :stop="tour.stop"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
          :highlight="myOptions.highlight"
          :useKeyboardNavigation="myOptions.useKeyboardNavigation"
        >
          <template slot="actions">
            <div class="v-step__buttons">
              <button
                @click="tour.previousStep"
                v-if="!tour.isFirst"
                class="v-step__button v-step__button-previous"
              >
                {{ myOptions.labels.buttonPrevious }}
              </button>
              <button
                @click="tour.nextStep"
                v-if="!tour.isLast"
                class="v-step__button v-step__button-next"
              >
                {{ myOptions.labels.buttonNext }}
              </button>
              <button
                @click="tour.skip"
                v-if="!tour.isLast"
                class="v-step__button v-step__button-skip"
              >
                {{ myOptions.labels.buttonSkip }}
              </button>
              <button
                @click="tour.finish"
                v-if="tour.isLast"
                class="v-step__button v-step__button-stop"
              >
                {{ myOptions.labels.buttonStop }}
              </button>
            </div>
          </template>
        </v-step>
      </template>
      <!-- eslint-enalbe -->
    </v-tour>
    <v-tour
      v-else
      name="myTour"
      :steps="headerSmallSteps.concat(steps)"
      :options="myOptions"
      :callbacks="callbacks"
    >
      <!-- eslint-disable -->
      <template slot-scope="tour">
        <v-step
          v-if="tour.currentStep === index"
          v-for="(step, index) of tour.steps"
          :key="index"
          :step="step"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :stop="tour.stop"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
          :highlight="myOptions.highlight"
          :useKeyboardNavigation="myOptions.useKeyboardNavigation"
        >
          <template slot="actions">
            <div class="v-step__buttons">
              <button
                @click="tour.previousStep"
                v-if="!tour.isFirst"
                class="v-step__button v-step__button-previous"
              >
                {{ myOptions.labels.buttonPrevious }}
              </button>
              <button
                @click="tour.nextStep"
                v-if="!tour.isLast"
                class="v-step__button v-step__button-next"
              >
                {{ myOptions.labels.buttonNext }}
              </button>
              <button
                @click="tour.skip"
                v-if="!tour.isLast"
                class="v-step__button v-step__button-skip"
              >
                {{ myOptions.labels.buttonSkip }}
              </button>
              <button
                @click="tour.finish"
                v-if="tour.isLast"
                class="v-step__button v-step__button-stop"
              >
                {{ myOptions.labels.buttonStop }}
              </button>
            </div>
          </template>
        </v-step>
      </template>
      <!-- eslint-enalbe -->
    </v-tour>
  </vs-row>
</template>
<script>
// //////////////////////////////////////////
// Import Components Here
// //////////////////////////////////////////
import SalesSummery from "../dashboard-components/sales-summery/SalesSummery";
import EmailCampaign from "../dashboard-components/email-campaign/EmailCampaign";
//import ActiveVisitors from "../dashboard-components/active-visitors/ActiveVisitors";
import MonthTable from "../dashboard-components/month-table/MonthTable";
//import RevenueStatics from "../../widgets/chart-widgets/revenue-statics/RevenueStatics";
//import PageViews from "../../widgets/chart-widgets/page-views/PageViews";
//import BounceRate from "../../widgets/chart-widgets/bounce-rate/BounceRate";
import MultislideCarousel from "../../extra-components/carousel/MultislideCarousel";
import Footer from "../../extra-components/Footer";
import PointsExchangeModule from "../../pages/components/PointsExchangeModule";
import GalleryCarousel from "../../extra-components/carousel/GalleryCarousel";
import VueApexCharts from "vue-apexcharts";

import saldoDataMixin from "../../../mixins/saldoDataMixin.js";
import userDataMixin from "../../../mixins/userDataMixin.js";
import voucherDataMixin from "../../../mixins/voucherDataMixin.js";
import historyDataMixin from "../../../mixins/historyDataMixin.js";
import blogPostsDataMixin from "../../../mixins/blogPostDataMixin.js";
import tutorialDataMixin from "../../../mixins/tutorialDataMixin.js";

// //////////////////////////////////////////
// Export Here
// //////////////////////////////////////////
export default {
  name: "PanelKlubowicza",
  mixins: [
    userDataMixin,
    saldoDataMixin,
    voucherDataMixin,
    historyDataMixin,
    blogPostsDataMixin,
    tutorialDataMixin
  ],
  data: () => ({
    title: "Panel klubowicza",
    name: "",
    surname: "",
    email: "",
    saldo: [],
    saldo_history: [],
    saldo_labels: [],
    active_vouchers: "",
    voucher_amounts: [],
    used_sum: "",
    points_history: "",
    saved_money: "",
    history: [],
    errors: [],
    //level: [],
    posts: [],
    windowWidth: window.innerWidth,
    headerSmallSteps: [
      {
        target: "#v-step-header",
        content: `Witamy w Klubie Okazji! Za pomocą tego wprowadzenia nauczysz się korzystać ze strony.`,
        params: {
          enableScrolling: false
        }
      }
    ],
    headerDesktopSteps: [
      {
        target: "#v-step-header",
        content: `Witamy w Klubie Okazji! Za pomocą tego wprowadzenia nauczysz się korzystać ze strony.`,
        params: {
          enableScrolling: false
        }
      },
      {
        target: "#v-step-header-1",
        content: `Pierwszy przycisk służy do otwarcia samouczka. Możesz z niego skorzystać kiedy tylko chcesz.`,
        params: {
          enableScrolling: false
        }
      },
      {
        target: ".v-step-header-2",
        content: `Zawsze, gdy masz pytania możesz skontaktować się z naszym konsultantem.`,
        params: {
          enableScrolling: false
        }
      },
      {
        target: ".v-step-header-3",
        content: `Możesz też wysłać wiadomość.`,
        params: {
          enableScrolling: true
        }
      },
      {
        target: "#v-step-header-5",
        content: `Przycisk włączający i wyłączający ciemny styl strony.`,
        params: {
          enableScrolling: true,
          placement: "left"
        },
        offset: 0.1
      },
      {
        target: "#v-step-header-4",
        content: `W tym miejscu znajduje się przejście do ustawień Twojego profilu.`,
        params: {
          enableScrolling: true,
          placement: "left"
        },
        offset: 0.1
      }
    ],
    steps: [
      {
        target: "#v-step-0",
        content: `Główny ekran Klubu Okazji pokazuje informacje na temat Twoich punktów.`,
        params: {
          enableScrolling: false
        }
      },
      {
        target: "#v-step-1",
        content: `W tym miejscu widzisz liczbę swoich punktów.`,
        params: {
          enableScrolling: false
        },
        offset: -150
      },
      {
        target: "#v-step-2",
        content: `Ten przycisk przenosi Cię do ekranu wymiany punktów na rabaty.`,
        params: {
          enableScrolling: false
        },
        offset: -150
      },
      {
        target: "#v-step-3",
        content: `Ta sekcja pokazuje, ile pieniędzy zaoszczędziłeś dzięki Klubowi Okazji.`,
        params: {
          enableScrolling: false
        },
        offset: -150
      },
      {
        target: "#v-step-4",
        content: `W tym miejscu możesz zobaczyć krótkie podsumowanie Twoich punktów. `,
        offset: -150
      },
      {
        target: "#v-points-step-0",
        content: `Ekran podsumowania pokazuje wszystkie aktywne kupony, które możesz wykorzystać.`,
        params: {
          enableScrolling: false
        }
      },
      {
        target: "#v-points-step-1",
        content: `Kupony mogą przyznawać zniżkę lub umożliwiać zdobycie prezentu. `,
        offset: -150
      },
      {
        target: ".v-points-step-2",
        content: `W tym miejscu widzisz ilość dostępnych punktów, które możesz zamienić na kupony. Każda wydana na zakupy złotówka powoduje przyznanie jednego punktu.`,
        offset: -150
      },
      {
        target: "#v-points-step-3",
        content: `Aby wymienić punkty na kupon zniżkowy, należy kliknąć przycisk „wymień”.`,
        offset: -150
      },
      {
        target: "#v-points-step-4",
        content: `Aby wymienić punkty na kupon przyznający upominek, należy kliknąć przycisk „wymień”.`,
        offset: -150
      },
      {
        target: "#v-step-5",
        content: `Na tym wykresie zobaczysz, jakie typy kuponów wykorzystałeś.`,
        offset: -150
      },
      {
        target: "#v-step-6",
        content: `W tym miejscu zobaczysz link do najnowszego artykułu na naszym blogu - zapraszamy do lektury!`,
        offset: -151
      },
      {
        target: "#v-step-7",
        content: `Ta sekcja pokazuje, ile kuponów zniżkowych już wykorzystałeś.`,
        offset: -150
      },
      {
        target: "#v-step-8",
        content: `Ta sekcja pokazuje, ile punktów zgromadziłeś na swoim koncie.`,
        offset: -150
      },
      {
        target: "#v-step-9",
        content: `Na wykresie możesz zobaczyć ile punktów zebrałaś w poszczególnych miesiącach.`,
        offset: -150
      },
      {
        target: "#v-step-10",
        content: `W tej tabeli zobaczysz pełną historię swoich kuponów rabatowych.`,
        offset: -150
      },
      {
        target: "#v-step-11",
        content: `Artykuły blogowe - w tej sekcji zobaczysz kilka najnowszych wpisów.`,
        offset: -150
      }
    ],
    myOptions: {
      useKeyboardNavigation: true,
      labels: {
        buttonPrevious: "Poprzedni",
        buttonNext: "Następny",
        buttonStop: "Koniec",
        buttonSkip: "Zamknij podpowiedź"
      },
      startTimeout: 20,
      highlight: true
    }
  }),
  components: {
    SalesSummery,
    EmailCampaign,
    //ActiveVisitors,
    MonthTable,
    //RevenueStatics,
    //PageViews,
    //BounceRate,
    MultislideCarousel,
    GalleryCarousel,
    Footer,
    VueApexCharts,
    PointsExchangeModule
  },
  created() {
    this.getData();
    this.getUserSaldo();
    this.getUserSaldoHistory({
      weeks: 14
    });
    this.getUserPointsHistory();
    this.getActiveVouchers();
    this.getVouchersAmount();
    this.getUsedVouchersHistory();
    this.getHistory({
      limit: 10
    });
    //this.getLevel();
    this.getBlogPosts();
  },
  updated() {},
  mounted: function() {
    this.$tours["myTour"].start();
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
  methods: {
    startCallback() {
      // eslint-disable-next-line
      if (sessionStorage.getItem("dashboardTutorial") === "true") this.stop();
    },
    endCallback() {
      sessionStorage.setItem("dashboardTutorial", "true");
      this.setTutorialStatus("dashboard");
    },
    refreshUserData() {
      this.getData();
      this.getUserSaldo();
      this.getUserSaldoHistory({
        weeks: 14
      });
      this.getUserPointsHistory();
      this.getActiveVouchers();
      this.getVouchersAmount();
      this.getUsedVouchersHistory();
      this.getHistory({
        limit: 10
      });
    }
  },
  computed: {
    callbacks: function() {
      return {
        onStart: this.startCallback,
        onFinish: this.endCallback,
        onSkip: this.endCallback
      };
    },
    series: function() {
      return [
        {
          name: "Punkty dostępne",
          data: this.saldo_history.map(x => Number(x))
        }
      ];
    },
    chartOptions: function() {
      let options = {
        dataLabels: { enabled: false },
        chart: { toolbar: { show: false }, zoom: { enabled: false } },
        stroke: { curve: "smooth", width: 2 },
        colors: ["#4fc3f7", "#2962FF", "#f62d51", "#ffbc34", "#212529"],
        xaxis: {
          categories: this.saldo_labels,
          labels: { style: { cssClass: "text-muted fill-color" } }
        },
        yaxis: {
          labels: { style: { cssClass: "text-muted fill-color" } }
        },
        markers: { size: 3 },
        tooltip: {
          enabled: false,
          show: false
        },
        legend: { show: false },
        grid: {
          show: true,
          borderColor: "rgba(0,0,0,0.1)"
        }
      };
      return options;
    }
  }
};
</script>
<style lang="scss">
.swiper-container {
  background-color: #f0f5f9;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
  height: 400px;
}

.coin-icon {
  font-size: 225px;
  color: white;
  position: absolute;
  top: -100px;
  left: 55%;
}

.coin-icon-container {
  position: relative;
}

.info-card {
  height: 215px;
  overflow: hidden;
}
#v-step-9.info-card .vs-card--content {
  padding: 10px;
}
.voucher-icon {
  font-size: 200px;
  color: white;
  position: absolute;
  top: -95px;
}

.piggy-icon {
  font-size: 200px;
  position: absolute;
  // right: -70px;
  top: -150px;
}

@media only screen and (max-width: 340px) {
  .piggy-icon {
    display: none;
  }
}
@media only screen and (max-width: 399px) {
  .voucher-icon {
    font-size: 160px;
    top: -70px;
  }
}

@media only screen and (min-width: 901px) and (max-width: 1149px) {
  .voucher-icon {
    font-size: 160px;
    top: -70px;
  }
}

@media only screen and (min-width: 901px) and (max-width: 1279px) {
  .voucher-container .vs-xs-8.vs-lg-6 {
    width: 75% !important;
  }

  .voucher-container .vs-xs-4.vs-lg-6 {
    width: 25% !important;
  }
}
</style>
